import { useUserRole } from '@/hooks/useUserRole'
import { USER_MANAGEMENT_POLICIES } from '../constants'

export function useUserManagementEditPermissions() {
  const { hasPolicy, isAdmin, isLibertyRole, isCompanyRole, roleName, user: currentAuthUser } =
    useUserRole()

  return {
    isAdmin,
    isLibertyRole,
    isCompanyRole,
    roleName: roleName ?? '',
    currentUserId: currentAuthUser?.user_id ?? null,
    canTempPassword: hasPolicy([USER_MANAGEMENT_POLICIES.TEMP_PASSWORD]),
    canDisableEnable: hasPolicy([USER_MANAGEMENT_POLICIES.DISABLE_ENABLE]),
    canAddNotes: hasPolicy([USER_MANAGEMENT_POLICIES.ADD_NOTES]),
    canSetFinMgr: hasPolicy([USER_MANAGEMENT_POLICIES.SET_FINANCE_MGR]),
    canRemoveRole: hasPolicy([USER_MANAGEMENT_POLICIES.ROLE_REMOVE]),
    canEditRole: hasPolicy([USER_MANAGEMENT_POLICIES.ROLE_EDIT]),
    canImpersonateApplicant: hasPolicy([USER_MANAGEMENT_POLICIES.IMPERSONATE_APPLICANT]),
    canImpersonatePmc: hasPolicy([USER_MANAGEMENT_POLICIES.IMPERSONATE_PMC]),
    canSelfAssignProps: hasPolicy([USER_MANAGEMENT_POLICIES.SELF_ASSIGN_PROPS]),
  }
}
